import React from "react";
import { Button } from "primereact/button";
import { PAYOUT_COPY } from "../ThgAnnualSummary.consts";

interface SyncButtonProps {
  syncing: boolean;
  disabled: boolean;
  onSync: () => void;
}

/**
 * Re-reads the year's draft and final credit notes from the accounting system, to pick up ones finalised or
 * cancelled there. Only statuses change, so it needs no confirmation. The backend also does this nightly.
 */
const SyncButton: React.FC<SyncButtonProps> = ({ syncing, disabled, onSync }) => (
  <Button
    label={PAYOUT_COPY.sync}
    icon="pi pi-sync"
    outlined
    size="small"
    loading={syncing}
    disabled={disabled}
    onClick={onSync}
  />
);

export default SyncButton;
